import { MotionBox as Box, MotionFlex, viewAppearDefault, staggeredAppear } from "utils/motion";
import Text from "components/base/Text";
import Container from "components/base/Container";

export default function DarkQuoteSection({
  title,
  description,
  isInverted,
  children,
  childrenOnTop,
  bg,
  ...props
}) {
  return (
    <Box
      width="100%"
      bg={bg || (isInverted ? "white" : "black.900")}
      {...props}
      title={null}
    >
      <Container color="white">
        <MotionFlex
          variants={staggeredAppear}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.4 }}
          direction="column"
          align="center"
        >
          {childrenOnTop && (
            <Box
              justifySelf={["start", null, "center"]}
              variants={viewAppearDefault}
              py="md"
            >
              {children}
            </Box>
          )}
          <Text
            type="headline_md"
            align="center"
            color={isInverted ? "black.900" : "white"}
            variants={viewAppearDefault}
            maxWidth="720px"
          >
            {title}
          </Text>
          <Text
            type="p_lg"
            pt={[4, null, 8]}
            align="center"
            color={isInverted ? "black.900" : "white"}
            w={["90%", null, "75%"]}
            variants={viewAppearDefault}
          >
            {description}
          </Text>
          {!childrenOnTop && (
            <Box
              justifySelf={["start", null, "center"]}
              variants={viewAppearDefault}
            >
              {children}
            </Box>
          )}
        </MotionFlex>
      </Container>
    </Box>
  );
}
